<template>
  <div>
    <b-card v-if="isAdmin" class="mb-5" title="New Contract">
      <b-row>
        <b-col>
          <b-form-group label="Seller">
            <b-form-select v-model="newContract.seller_id" :options="companyOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Buyer">
            <b-form-select v-model="newContract.buyer_id" :options="companyOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Contract Type">
            <b-form-select v-model="newContract.billing">
              <option value="WE_COLLECT">SmartRTB Collects</option>
              <option value="THEY_COLLECT">Seller Collects</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Save">
            <b-btn variant="primary" @click="createContract">Create</b-btn>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <table-card title="Contracts"
                :items="contracts"
                :fields="fields">
      <template v-slot:cell(buyer_name)="data">
        {{ companyCache[data.item.buyer_id] }}
      </template>
      <template v-slot:cell(seller_name)="data">
        {{ companyCache[data.item.seller_id]}}
      </template>
      <template v-slot:cell(billing)="data">
        <b-badge v-if="data.value === 'WE_COLLECT'">SmartRTB Collects</b-badge>
        <b-badge v-if="data.value === 'THEY_COLLECT'">Seller Paid Directly</b-badge>
      </template>
    </table-card>
  </div>
</template>

<script>
    import auth from '@/auth'
    import {MiscApi} from "../../api"
    import {CompanyApi} from "../../company/api"
    import TableCard from "../TableCard"
    import Mulselect from "../Mulselect"

    export default {
        name: 'Contracts',
        created() {
            if (auth.isAdmin()) {
                MiscApi.getContractList().then((list) => {
                    this.contracts.push(...list)

                    this.loadCompanyDetails()
                })

                CompanyApi.list().then((list) => {
                    let opts = {}
                    for (let co of list) {
                        opts[co.id] = co.name
                    }

                    this.companyOptions = opts
                })

                return
            }

            let cid = auth.details().company_id

            let promises = []
            if (auth.publisher() != null || auth.exchange() != null) {
                let p = MiscApi.getContractsBySeller(cid).then((list) => {
                    this.contracts.push(...list)
                })
                promises.push(p)
            }
            if (auth.demand() != null) {
                let p = MiscApi.getContractsByBuyer(cid).then((list) => {
                    this.contracts.push(...list)
                })
                promises.push(p)
            }

            Promise.all(promises).then(() => {
                this.loadCompanyDetails()
            })
        },
        data() {
            return {
                companyOptions: [],
                newContract: {
                    billing: "WE_COLLECT"
                },
                contracts: [],
                fields: [
                    {key: 'id', label: 'Contract Id'},
                    {key: 'seller_name', label: 'Seller Name'},
                    {key: 'seller_id', label: 'Seller Id'},
                    {key: 'buyer_name', label: 'Buyer Name'},
                    {key: 'buyer_id', label: 'Buyer Id'},
                    {key: 'billing', label: 'Billing'}
                ],
                companyCache: {}
            }
        },
        methods: {
            createContract() {
              let nc = this.newContract
              if(!nc.seller_id || !nc.buyer_id) {
                  this.$notify.error("Buyer and seller must be set")
                  return
              }

              MiscApi.contractSave(nc).then((c) => {
                  this.contracts.push(c)
              }).catch((e) => {
                  this.$notify.error("Error saving contract")
              })
            },
            loadCompanyDetails() {
                let cache = []

                let loading = new Set()
                for (let c of this.contracts) {
                    let sid = c.seller_id
                    let bid = c.buyer_id

                    if (!loading.has(sid)) {
                        loading.add(sid)
                    }
                    if (!loading.has(bid)) {
                        loading.add(bid)
                    }
                }

                let promises = []
                for (let cid of loading.values()) {
                    if (!cache[cid]) {
                        let promise = CompanyApi.details(cid).then((details) => {
                            cache[details.id] = details.name
                        })

                        promises.push(promise)
                    }
                }

                return Promise.all(promises).then(() => {
                    this.$nextTick(() => {
                        this.companyCache = cache
                    })
                })
            }
        },
        computed: {
            isAdmin() {
                return auth.isAdmin()
            }
        },
        components: {
            Mulselect,
            TableCard
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/Contracts.vue